// @ts-nocheck
/* eslint-enable */
// App
import React from 'react';
import { useSelector } from 'react-redux';

// Hooks
import { useHtmlTagSwap } from './hooks';

// Components
import SrpContentWrapper from 'app/shared/modules/MobileSRP/__BaseComponents__/SrpContentWrapper';

// Misc / utils
import * as S from './styles';

const ArticlesAndFaq = () => {
  // Redux
  const articleAndFaqData = useSelector((state) => state.area.articles);
  const areaName = useSelector((state) => state.area.area.name);

  // Hooks
  const { formattedHtmlString } = useHtmlTagSwap(articleAndFaqData);

  if (articleAndFaqData.length < 1) {
    return null;
  }

  return (
    <SrpContentWrapper identifier={'article-section'} title={`About ${areaName}`}>
      <S.FaqContent dangerouslySetInnerHTML={{ __html: formattedHtmlString }} />
    </SrpContentWrapper>
  );
};

export default ArticlesAndFaq;
